import type { DeepPartial } from '@luna/utils-ts';

import type { Overview } from '../../types/Overview';

export const overviewSKFeatureConfig: DeepPartial<Overview> = {
    getSumPerTypeTotalMarketValue: true,
    showPriceTooltip: true,
    showTradingButton: true,
    sortAttribute: '-marketValue',
    stockValueTooltip: true,
    sumValueFromPositions: true,
    sumValueFromPerformance: true,
    totalMarketValueFromPositions: true,
};
